import gql from 'graphql-tag';

export const DraftSyncMutation = gql`
	mutation DraftSyncMutation(
		$contentId: ID!
		$contentType: String!
		$content: String!
		$title: String
		$ncsStepVersion: String!
	) @experimental {
		experimentalDraftSync(
			contentId: $contentId
			contentType: $contentType
			content: $content
			title: $title
			ncsStepVersion: $ncsStepVersion
		) {
			id
		}
	}
`;
